import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tripTypePipe'
})
export class TripTypePipePipe implements PipeTransform {

  transform(value: any) {
    if(value=="D" || value==1){return "Drop";}
    else if(value=="P" || value==2 ){return "Pick Up";}
    else {return ""};
  }

}
